import React from 'react'
import { t } from '@billes/translator-client'

const Empty = ({ translationKey, Icon }) => {
  return (
    <div
      style={{
        width: '100%',
        height: '70%',
        background: 'transparent',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {Icon ? <Icon /> : null}
      <span style={{ fontSize: 13, color: '#adadad' }}>
        {t(translationKey)}
      </span>
    </div>
  )
}

export default Empty



// WEBPACK FOOTER //
// ./src/components/Common/Empty/empty.js